/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { Fragment } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router'
import { CheckJustificativaAcessoProntuario } from 'view/prontuario/justificativa/CheckJustificativaAcessoProntuario'

import { AcompanhamentosContent } from './AcompanhamentosContent'
import { AcompanhamentosSideMenu } from './side-menu/AcompanhamentosSideMenu'

export const ACOMPANHAMENTOS_PRE_NATAL_URL = 'acompanhamentos/pre-natal'

interface AcompanhamentosViewProps {
  cidadaoId: ID
  prontuarioId: ID
  atendimentoId?: ID
  isGestante: boolean
  isVisualizacaoProntuario: boolean
  dataReferencia?: Instant
}

export function AcompanhamentosView(props: AcompanhamentosViewProps) {
  const { cidadaoId, prontuarioId, atendimentoId, isGestante, isVisualizacaoProntuario, dataReferencia } = props
  const styles = createStyles(isVisualizacaoProntuario)

  const match = useRouteMatch()
  const history = useHistory()
  const location = useLocation()

  const basePath = match.url.replace(`/${ACOMPANHAMENTOS_PRE_NATAL_URL}`, '')
  const vacinacaoPath = `${basePath}/vacinacao${location.search}`

  const handleSoapButtonClick = () => {
    history.push(`${basePath}/soap`)
  }

  return (
    <Fragment>
      {isGestante && (
        <PageContent fluid type='filled'>
          <CheckJustificativaAcessoProntuario
            prontuarioId={prontuarioId}
            cidadaoId={cidadaoId}
            basePath={basePath}
            disabled={!!atendimentoId || !isVisualizacaoProntuario}
          >
            <Grid gap={2}>
              <Cell size={3} style={styles.sideCell}>
                <AcompanhamentosSideMenu />
                {!isVisualizacaoProntuario && (
                  <Button onClick={handleSoapButtonClick} style={styles.button}>
                    Ir para o SOAP
                  </Button>
                )}
              </Cell>
              <Cell size={9}>
                <AcompanhamentosContent
                  prontuarioId={prontuarioId}
                  atendimentoId={atendimentoId}
                  cidadaoId={cidadaoId}
                  dataReferencia={dataReferencia}
                  vacinacaoPath={vacinacaoPath}
                />
              </Cell>
            </Grid>
          </CheckJustificativaAcessoProntuario>
        </PageContent>
      )}
    </Fragment>
  )
}

const createStyles = (isVisualizacao: boolean) => ({
  sideCell: css`
    position: sticky;
    align-items: start;
    top: ${isVisualizacao ? '1rem' : '7.5rem'};
    height: 100%;
  `,

  button: css`
    width: 100%;
    margin-top: 1rem;
  `,
})
